// src/pages/Login.js
import React, { useState } from "react";
import { signInWithEmailAndPassword } from "firebase/auth";
import { auth } from "../firebase";
import { useNavigate } from "react-router-dom";
import { doc, getDoc } from "firebase/firestore";
import { db } from "../firebase";



export default function Login() {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const navigate = useNavigate();   // <-- ADD THIS
  
  

  const doLogin = async () => {
  try {
    const cred = await signInWithEmailAndPassword(auth, email, password);

    // 🔐 fetch role from users collection
    const userRef = doc(db, "users", cred.user.uid);
    const userSnap = await getDoc(userRef);




    if (!userSnap.exists()) {
      alert("User role not mapped. Contact admin.");
      return;
    }

    const { role } = userSnap.data();

    // 🔁 ROLE BASED REDIRECT (FINAL)
if (role === "salesman") {
  navigate("/base", { replace: true });
  
  

} else if (role === "warehouse") {
  navigate("/warehouse-close", { replace: true });

} else if (role === "admin" || role === "superadmin") {
  navigate("/operator", { replace: true }); // Dashboard


    } else if (role === "wholesale" || role === "swd" || role === "npsr") {
      navigate("/base", { replace: true });

} else if (role === "cashier") {
  navigate("/cashier-Approval", { replace: true }); // Dashboard

} else if (role === "collection") {
  navigate("/cashier", { replace: true }); // Dashboard




} else {
  // operator
  navigate("/pending-orders", { replace: true });
}


  } catch (err) {
    console.error(err);
    alert("Login failed");
  }
};

  
  
  return (
    <div style={styles.container}>
      <div style={styles.overlay}></div>

      <div style={styles.loginBox}>
        <h2 style={styles.title}>QuickBill</h2>

        <input
          type="email"
          style={styles.input}
          placeholder="Email Address"
          value={email}
          onChange={(e) => setEmail(e.target.value)}
        />

        <input
          type="password"
          style={styles.input}
          placeholder="Password"
          value={password}
          onChange={(e) => setPassword(e.target.value)}
        />

        <button style={styles.loginBtn} onClick={doLogin}>
          Login
        </button>
      </div>
    </div>
  );
}

// ---------------- STYLES ----------------

const styles = {
  container: {
    width: "100vw",
    height: "100vh",
    backgroundImage:
      "url('https://images.unsplash.com/photo-1581091870620-3f94b1bcd4c0?auto=format&fit=crop&w=1950&q=80')",
    backgroundSize: "cover",
    backgroundPosition: "center",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    position: "relative",
  },

  overlay: {
    position: "absolute",
    top: 0,
    left: 0,
    width: "100%",
    height: "100%",
    background: "rgba(0,0,0,0.55)",
    backdropFilter: "blur(2px)",
  },

  loginBox: {
    position: "relative",
    width: "90%",
    maxWidth: 400,
    background: "rgba(255,255,255,0.95)",
    padding: "30px",
    borderRadius: 12,
    boxShadow: "0px 4px 30px rgba(0,0,0,0.3)",
    textAlign: "center",
  },

  title: {
    marginBottom: 25,
    fontSize: 28,
    fontWeight: "700",
    color: "#222",
  },

  input: {
    width: "100%",
    padding: "12px",
    borderRadius: 8,
    border: "1px solid #ccc",
    marginBottom: 15,
    fontSize: 16,
  },

  loginBtn: {
    width: "100%",
    padding: "12px",
    background: "#007bff",
    color: "white",
    border: "none",
    borderRadius: 8,
    cursor: "pointer",
    fontSize: 18,
    fontWeight: "600",
  },
};
